/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProgramDashboardDto } from './ProgramDashboardDto';
import {
    ProgramDashboardDtoFromJSON,
    ProgramDashboardDtoFromJSONTyped,
    ProgramDashboardDtoToJSON,
    ProgramDashboardDtoToJSONTyped,
} from './ProgramDashboardDto';
import type { ChildTenantPortfolioDto } from './ChildTenantPortfolioDto';
import {
    ChildTenantPortfolioDtoFromJSON,
    ChildTenantPortfolioDtoFromJSONTyped,
    ChildTenantPortfolioDtoToJSON,
    ChildTenantPortfolioDtoToJSONTyped,
} from './ChildTenantPortfolioDto';

/**
 * 
 * @export
 * @interface ProgramPortfolioDashboardDto
 */
export interface ProgramPortfolioDashboardDto {
    /**
     * 
     * @type {ProgramDashboardDto}
     * @memberof ProgramPortfolioDashboardDto
     */
    aggregate?: ProgramDashboardDto;
    /**
     * 
     * @type {Array<ChildTenantPortfolioDto>}
     * @memberof ProgramPortfolioDashboardDto
     */
    childTenants?: Array<ChildTenantPortfolioDto>;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramPortfolioDashboardDto
     */
    hasChildTenants?: boolean;
}

/**
 * Check if a given object implements the ProgramPortfolioDashboardDto interface.
 */
export function instanceOfProgramPortfolioDashboardDto(value: object): value is ProgramPortfolioDashboardDto {
    return true;
}

export function ProgramPortfolioDashboardDtoFromJSON(json: any): ProgramPortfolioDashboardDto {
    return ProgramPortfolioDashboardDtoFromJSONTyped(json, false);
}

export function ProgramPortfolioDashboardDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramPortfolioDashboardDto {
    if (json == null) {
        return json;
    }
    return {
        
        'aggregate': json['aggregate'] == null ? undefined : ProgramDashboardDtoFromJSON(json['aggregate']),
        'childTenants': json['childTenants'] == null ? undefined : ((json['childTenants'] as Array<any>).map(ChildTenantPortfolioDtoFromJSON)),
        'hasChildTenants': json['hasChildTenants'] == null ? undefined : json['hasChildTenants'],
    };
}

export function ProgramPortfolioDashboardDtoToJSON(json: any): ProgramPortfolioDashboardDto {
    return ProgramPortfolioDashboardDtoToJSONTyped(json, false);
}

export function ProgramPortfolioDashboardDtoToJSONTyped(value?: ProgramPortfolioDashboardDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'aggregate': ProgramDashboardDtoToJSON(value['aggregate']),
        'childTenants': value['childTenants'] == null ? undefined : ((value['childTenants'] as Array<any>).map(ChildTenantPortfolioDtoToJSON)),
        'hasChildTenants': value['hasChildTenants'],
    };
}

